if (!customElements.get('product-stock')) {
    class ProductStock extends ErpConnection {
        constructor() {
            super();
            
            this.i18n = this.querySelector('[data-i18n]');
            this.configuration = this.querySelector('[data-configuration]');            
            this.deliveryContainer = this.querySelector('.product-item__delivery');
            
            try {
                this.i18n = JSON.parse(this.i18n.innerText);
                this.configuration = JSON.parse(this.configuration.innerText);
            } catch (err) {
                this.i18n = null;
                this.configuration = null;
            }

            if (this.configuration == null) { return; }

            fetch(this.ENDPOINT + "/stock?" + new URLSearchParams({
                item_id: this.configuration.item_id,
                account_id: document.body.dataset.customer_account_id,
                company: this.configuration.company
            }), {
                method: "GET",
                headers: this.HEADER.GET
            }).then(res => {
                if (res.status == 200) {
                    return res.json();
                } else {
                    throw 'err';
                }
            }).then(body => {                
                if (body && body.amount != undefined && body.amount != null) {
                    this.deliveryContainer.style.display = "block";
                    if (this.configuration.isDetailPage == true && body.amount > 0) {
                        document.getElementById('product_delivery_info').style.display = "block";
                    }
                    switch (this.configuration.display) {
                        case "text":
                            if (body.amount > 0) {
                                this.deliveryContainer.innerHTML = (body.amount < 20) ? this.i18n.low_stock : this.i18n.in_stock;
                            } else {
                                this.deliveryContainer.classList.add('delivery_not_available');
                                this.deliveryContainer.innerHTML = this.i18n.sold_out;
                            }
                            break;
                        case "amount":
                            this.deliveryContainer.innerHTML = body.amount;
                            break;
                    }
                }
            }).catch(err => {
                console.error("ERROR:" , err);
            });
        }
    }    
    customElements.define('product-stock', ProductStock);
}